







































import ExercisesFormSwitcher from '@/components/exercises/forms/ExercisesFormSwitcher.vue'
import ExercisesFormSwitchButton from '@/components/exercises/forms/ExercisesFormSwitchButton.vue'
import { withDefault } from '@/components/exercises/measure/filters'

export default {
  components: {
    ExercisesFormSwitcher,
    ExercisesFormSwitchButton,
  },
  filters: {
    withDefault,
  },
  props: {
    feedbackRating: {
      type: String,
      default: '',
    },
    feedbackMoreWorkLoad: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'row',
    },
  },
  data() {
    return {
      typeRowRatingConfig: {
        cols: 12,
        md: 4,
      },
      typeRowHigherWorkloadColConfig: {
        cols: 12,
        md: 6,
      },
      typeColConfig: {
        cols: 12,
      },
    }
  },
  computed: {
    baseClasses() {
      return this.direction === 'row' ? null : ['flex-column']
    },
    ratingVColConfig() {
      return this.direction === 'row' ? this.typeRowRatingConfig : this.typeColConfig
    },
    higherWorkloadVColConfig() {
      return this.direction === 'row' ? this.typeRowHigherWorkloadColConfig : this.typeColConfig
    },
  },
}
